import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import "./plugins"
import i18n from "./i18n/i18n";
import Cut from "../src/components/changeLang";
import VueHighlightJS from 'vue-highlightjs';
import 'highlight.js/styles/atom-one-dark.css';
import md5 from 'js-md5';
import './assets/iconfont/iconfont.css'
import '@/assets/fonts/font-awesome.min.css'
import VueCryptojs from 'vue-cryptojs'
import * as Base64 from 'js-base64'
import '@/assets/css/global.css'
import '@/icons' // icon


Vue.component('changeLang', Cut)
Vue.prototype.$md5 = md5;
Vue.use(Base64)
Vue.use(VueCryptojs)
Vue.use(VueHighlightJS)
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
